module.exports = __webpack_public_path__ + "static/media/hero.663516e4.jpg";